import React, { useState,useEffect } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import ChecklistDetailsDisplay from './DDetailsDisplay';
import ChecklistArtifactsDisplay from './DocumentsArtifactsDisplay';
import { downloadDocument } from 'utils/DocumentsUtils'

const tabs = [
  new Tab({ label: "Edit", value: "Details" }),
  new Tab({ label: "Artifacts", value: "Artifacts" })
]

const DocumentsDetails = ({ documentistItem,callback }) => {
  const [activeTab, setActiveTab] = useState('Details');
  const [details, setDetails] = useState(documentistItem);


  useEffect(() => {
    async function anyNameFunction() {
     
      const download =  await downloadDocument(details)
      documentistItem.URL = download.url;
      setDetails(documentistItem)
      console.log(download)
    }

    anyNameFunction();
},[details])

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      {activeTab === "Details" ? <ChecklistDetailsDisplay key={1} defaultValues={details} loaded={!!details} CRUDType={"UPDATE"} callback={callback}/> : <ChecklistArtifactsDisplay artifact={details} />}
    </TabbedPage>
  )
}

export default DocumentsDetails;